<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div>
        <!-- <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs> -->
        <v-row class="fullscreen">
         <!-- <div class="fullscreen"> -->
                <!-- <p class="decode-result">Last result: <b>{{ result }}</b></p> -->
                <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
                <!-- <div v-show="showScanConfirmation" class="scan-confirmation">
                    <img src="../../assets/checkmark.png" alt="Checkmark" height="128px" width="128px" />
                </div> -->
                <v-dialog
                    v-model="showScanConfirmation"
                    width="500"
                    >
                    <v-card>
                        <v-card-text class="text-center">
                            <img src="../../assets/checkmark.png" alt="Checkmark" height="128px" width="128px" />
                        </v-card-text>
                    </v-card>
                    </v-dialog>
                </qrcode-stream>
            <!-- </div> -->
        </v-row>
        </div>
    </v-main>
  </div>
</template>
<script>
import { QrcodeStream, QrcodeDropZone } from 'vue-qrcode-reader'
export default {

  components: { QrcodeStream, QrcodeDropZone },

  data () {
    return {
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
      form: {
        shopId: '',
        rewardId: '',
        rewardCode: '',
        lineUserId: ''
      }
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  methods: {
    async onInit (promise) {
      try {
        await promise
      } catch (e) {
        console.error(e)
      } finally {
        this.showScanConfirmation = this.camera === 'off'
      }
    },

    async onDecode (content) {
      this.result = content
      if (content) {
        this.form.shopId = this.$route.query.shopId
        this.form.rewardId = this.$route.query.rewardId
        this.form.rewardCode = this.$route.query.rewardCode
        this.form.lineUserId = this.$route.query.lineUserId
        console.log(this.form)
        console.log(content)
        this.pause()
        await this.timeout(500)
        this.unpause()
      }
    },

    unpause () {
      this.camera = 'auto'
    },

    pause () {
      this.camera = 'off'
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    }
  }
}
</script>

<style scoped>
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
#img_container{
        border: 1px solid grey;
        height: 250px;
        width: 500px;
        display: table-cell;
        vertical-align: middle;
      }
      #img_container img{
        height: 100px;
        margin: auto auto;
        display: block;
      }
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, .8);
    /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/RedeemQRCode.vue